import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'numberToWordsWithCurrency',
    standalone: false
})
export class NumberToWordsWithCurrencyPipe implements PipeTransform {
  private units: string[] = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
  private teens: string[] = ['Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
  private tens: string[] = ['', 'Ten', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

  transform(value: number): string {
    if (value === 0) {
      return 'Rs. Zero Only';
    } else {
      const words = this.convertNumberToWords(value);
      // return `${words} Rupees`;
      return `Rs. ${words} Only`;
    }
  }

  private convertNumberToWords(number: number): string {
    if (number < 10) {
      return this.units[number];
    } else if (number === 10) {
      return 'Ten';
    } else if (number === 10000) {
      return 'Ten Thousand';
    } else if (number < 20) {
      return this.teens[number - 11];
    } else if (number < 100) {
      const tensWord = this.tens[Math.floor(number / 10)];
      const unitsWord = this.units[number % 10];
      return (unitsWord ? tensWord + ' ' + unitsWord : tensWord).trim();
    } else if (number < 1000) {
      return this.units[Math.floor(number / 100)] + ' Hundred ' + this.convertNumberToWords(number % 100);
    } else if (number < 100000) {
      return this.convertNumberToWords(Math.floor(number / 1000)) + ' Thousand ' + this.convertNumberToWords(number % 1000);
    } else if (number < 10000000) {
      return this.convertNumberToWords(Math.floor(number / 100000)) + ' Lakh ' + this.convertNumberToWords(number % 100000);
    } else if (number <= 1000000000) {
      return this.convertNumberToWords(Math.floor(number / 10000000)) + ' Crore ' + this.convertNumberToWords(number % 10000000);
    } else if (number <= 100000000000) {
      return this.convertNumberToWords(Math.floor(number / 1000000000)) + ' Hundred Crore ' + this.convertNumberToWords(number % 1000000000);
    } else if (number <= 10000000000000) {
      return this.convertNumberToWords(Math.floor(number / 1000000000000)) + ' Thousand Crore ' + this.convertNumberToWords(number % 1000000000000);
    } else if (number <= 1000000000000000) {
      return this.convertNumberToWords(Math.floor(number / 100000000000000)) + ' Lakh Crore ' + this.convertNumberToWords(number % 100000000000000);
    } else if (number <= 100000000000000000) {
      return this.convertNumberToWords(Math.floor(number / 10000000000000000)) + ' Crore Crore ' + this.convertNumberToWords(number % 10000000000000000);
    } else if (number <= 10000000000000000000) {
      return this.convertNumberToWords(Math.floor(number / 1000000000000000000)) + ' Thousand Crore Crore ' + this.convertNumberToWords(number % 1000000000000000000);
    } else {
      return '';
    }
  }

  // a = ['', 'One ', 'Two ', 'Three ', 'Four ', 'Five ', 'Six ', 'Seven ', 'Eight ', 'Nine ', 'Ten ', 'Eleven ', 'Twelve ', 'Thirteen ', 'Fourteen ', 'Fifteen ', 'Sixteen ', 'Seventeen ', 'Eighteen ', 'Nineteen '];
  // b = ['', '', 'Twenty', 'Thirty', 'Fourty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

  // transform(value: string): string {
  //   //if (value.length > 9) return 'overflow';
  //   if (value === '0') return 'Rs. Zero';
  //   // if (value === '1') return 'One Rupee';
  //   let n = ('0000000000000' + value).substr(-13).match(/^(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
  //   if (!n) return '';
  //   let str = '';
  //   str += 'Rs. ';
  //   str += (Number(n[1]) != 0) ? (this.a[Number(n[1])] || (this.b[Number(n[1][0])] + ' ' + this.a[Number(n[1][1])])) + 'kharab ' : '';
  //   str += (Number(n[2]) != 0) ? (this.a[Number(n[2])] || (this.b[Number(n[2][0])] + ' ' + this.a[Number(n[2][1])])) + 'Arab ' : '';
  //   str += (Number(n[3]) != 0) ? (this.a[Number(n[3])] || (this.b[Number(n[3][0])] + ' ' + this.a[Number(n[3][1])])) + 'Crore ' : '';
  //   str += (Number(n[4]) != 0) ? (this.a[Number(n[4])] || (this.b[Number(n[4][0])] + ' ' + this.a[Number(n[4][1])])) + 'Lakh ' : '';
  //   str += (Number(n[5]) != 0) ? (this.a[Number(n[5])] || (this.b[Number(n[5][0])] + ' ' + this.a[Number(n[5][1])])) + 'Thousand ' : '';
  //   str += (Number(n[6]) != 0) ? (this.a[Number(n[6])] || (this.b[Number(n[6][0])] + ' ' + this.a[Number(n[6][1])])) + 'Hundred ' : '';
  //   str += (Number(n[7]) != 0) ? ((str != 'Rs. ') ? 'And ' : '') + (this.a[Number(n[7])] || (this.b[Number(n[7][0])] + ' ' + this.a[Number(n[7][1])])) : '';
  //   //str += 'Rupees';
  //   return str.trim();
  // }

}